module.exports = __webpack_public_path__ + "static/img/831c21231347829def54dbe96ec3ac04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bk_box.png
// module id = nKKK
// module chunks = 1